<template>
  <div>
    <div class="class-head">
      <div class="class-flex">
        <p class="date" v-bind:class="{ active_date: isDay }" @click="dayOrWeekClick(true)">今</p>
        <p class="week" @click="isWeekDataShow = true">
          <span v-if="curWeek === '本周'">本周</span>
          <span v-else v-cloak>第{{ curWeek }}周</span>
          <i class="fa fa-angle-down"></i>
        </p>
        <p class="date" v-bind:class="{ active_date: !isDay }" @click="dayOrWeekClick(false)">周</p>
      </div>
      <!-- 周数据下拉 -->
      <van-action-sheet
        v-model="isWeekDataShow"
        :actions="weekData"
        cancel-text="取消"
        @select="ChangeWeek"
      />
      <!-- 天 -->
      <ul class="yd-scrollnav-tab-item" v-show="isDay">
        <li
          v-for="(item, index) in weekTable"
          v-bind:key="index"
          v-bind:class="tab === index ? 'active_tab' : ''"
          @click="dayChange(item, index)"
        >
          <p v-cloak>{{ item.weekName }}</p>
          <p>{{ item.dateDay }}</p>
        </li>
      </ul>
      <!-- 周 -->
      <ul class="yd-scrollnav-tab-item" v-show="!isDay">
        <li
          class="scrollnav-btn-week"
          v-for="(item, index) in tableSchedule"
          v-bind:key="index"
          v-bind:class="tab === index ? 'active_tab' : ''"
          @click="changeTab(index)"
        >
          {{ item.AMorPMOrderName }}
        </li>
      </ul>
      <div class="radius"></div>
    </div>

    <div class="class_info">
      <!-- 天 -->
      <ul v-if="isDay">
        <li v-for="(item, index) in tableSchedule" :key="item.index">
          <img src="@/assets/homeSchool/clock-roundness-gray@2x.png" alt v-if="index === 0" />
          <img src="@/assets/homeSchool/clock-roundness-blue@2x.png" alt v-else />
          <span v-cloak>{{ item.AMorPMOrderName }}</span>
          <div
            class="class_text"
            style="padding:10px 30px"
            v-bind:style="{ padding: '5px 20px 0 20px', color: bg[index % 5].color, background: bg[index % 5].background }"
          >
            <div
              class
              v-for="(scheduleData, index) in liScheduleData"
              :key="index"
            >
              <div
                v-if="
                  scheduleData.AMorPM === item.AMorPM &&
                    scheduleData.AMorPMOrder === item.AMorPMOrder &&
                    scheduleData.Day === curDay
                "
                @click.stop="showDetail(scheduleData)"
              >
                <p class="address" style="padding: 0;  margin-bottom: 10px;">
                  {{ scheduleData.SubjectName }}&nbsp;{{
                    scheduleData.TeacherInfos
                      ? "|&nbsp;" + scheduleData.TeacherInfos + "&nbsp;|"
                      : ""
                  }}&nbsp;{{
                    scheduleData.BuildingName ? scheduleData.BuildingName + "&nbsp;|" : ""
                  }}&nbsp;{{ scheduleData.HouseName }}
                </p>
                <p style="padding: 0" class="time">
                  {{ scheduleData.StartTime }}-{{ scheduleData.EndTime }}
                </p>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <!-- 周 -->
      <ul v-else>
        <li v-for="(item, index) in weekTable" :key="index">
          <img src="@/assets/homeSchool/clock-roundness-gray@2x.png" alt v-if="index === 0" />
          <img src="@/assets/homeSchool/clock-roundness-blue@2x.png" alt v-else />
          <span v-cloak>{{ item.weekName }}</span>
          <p v-cloak>{{ item.dateDay }}</p>
          <div
            class="class_text"
            v-bind:style="{ color: bg[index % 5].color, background: bg[index % 5].background }"
          >
            <p class="address">
              <span
                v-for="(crouse, index) in tableScheduleData"
                :key="index"
                v-cloak
              >
                <span
                  v-if="
                    crouse.AMorPM === tableSchedule[tab].AMorPM &&
                      crouse.AMorPMOrder === tableSchedule[tab].AMorPMOrder &&
                      item.dateTime === crouse.ClassDate
                  "
                  >{{ crouse.SubjectName }}&nbsp;</span
                >
              </span>
            </p>
          </div>
        </li>
      </ul>
    </div>
    <!-- <yd-actionsheet :items="yearData" v-model="showYear" cancel="取消"></yd-actionsheet>
        <div v-if="isChange" class="change-bg" @click="closeChild">
            <div class="child-info">
                <div v-for="item in childList" v-bind:class="'change-active'" @click="changeChildBtn(item)">
                    {{item.FullNameStudent}}</div>
            </div>
            <img src="/View/HomeSchool/Image/change-bg.png" alt="" class="change-bg-img" />
    </div>-->
  </div>
</template>
<script>
import { Dialog } from 'vant'
/*
 *  本文件仅从原项目复制并简易调整而来
 *  原作者：王丹
 *  迁移自：2019-10-9 版本
 *  合并至版本： 2019-11-27 李坤
 */
export default {
  name: "center",
  data() {
    return {
      StudentID: "",
      tab: new Date().getDay() - 1, //当前周几
      type: "day",
      isChange: false,
      isDay: true,
      classData: {},
      curDay: 0, //当前周几
      curDate: "", //当前日期
      curWeek: "本周", //第几周
      weekTable: [], //课表星期和日期
      weekData: [], //下拉选择日期周次
      isWeekDataShow: false,
      tableSchedule: [], //课表节次
      tableScheduleData: [], //一周课表课程
      liScheduleData: [], //当天课表课程
      curricula: "",
      studentsData: [],
      sectionList: [
        "1节",
        "2节",
        "3节",
        "4节",
        "5节",
        "6节",
        "7节",
        "8节",
        "9节",
        "10节",
        "11节",
        "12节"
      ],
      zaoData: ["早1", "早2"],
      wanData: ["晚1", "晚2", "晚3", "晚4"],
      //学年学期
      yearID: 0,
      yearData: [],
      sessionID: 0,
      sessionData: [],
      bg: [
        { background: "rgba(52,121,205,0.1)", color: "rgba(38, 100, 209, 1)" },
        { background: "rgba(237,250,238,1)", color: "rgba(9,175,24,1)" },
        { background: "rgba(88,72,237,0.1)", color: "rgba(88,72,237,1)" },
        { background: "rgba(242,155,42,0.2)", color: "rgba(242,155,42,1)" },
        { background: "rgba(255,240,236,1)", color: "rgba(248,52,1,1)" },
        { background: "rgba(88,72,237,1)", color: "rgba(159,6,235,1)" }
      ]
    };
  },
  computed: {
    ChildrenID() {
      return this.$store.state.parentInfo.childData.ChildrenID;
    }
  },
  methods: {
    // 点击获取列表消息详情
    showDetail(item) {
      if (item.SubjectName) {
        Dialog.alert({
          message: `${item.SubjectName} ${
            item.TeacherInfos ? '| ' + item.TeacherInfos + ' |' : ''
          } ${item.BuildingName ? item.BuildingName + ' |' : ''} ${item.HouseName ? item.HouseName : ''}
      ${item.StartTime}-${item.EndTime}`
        })
      }
    },
    //获取周课表
    async getWeekTimeTable(startDate, endDate, weekOrday) {
      const params = {
        startDate: startDate,
        endDate: endDate,
        StudentID: this.StudentID
      };
      const res = await this.xyapi.get(
        this.xyMApi + "/api/MyTimeTable/GetWeekTimeTable",
        params
      );
      if (res.success) {
        var resData = res.data;
        this.classData = resData
        this.tableSchedule = resData.Times;
        this.tableSchedule.map(item => {
          if (item.AMorPM === "MS") {
            item.AMorPMOrderName = this.zaoData[item.Order];
          }
          // if (item.AMorPM === 'NS') {
          // }
          if (item.AMorPM === "ES") {
            item.AMorPMOrderName = this.wanData[item.Order];
          }
          if (item.AMorPM === "AM" || item.AMorPM === "PM") {
            item.AMorPMOrderName = this.sectionList[item.Order];
          }
          return item;
        });
        if (resData.TimeTables.length > 1) {
          var array = [];
          for (var i = 0; i < resData.TimeTables.length; i++) {
            var index = array.indexOf(String(resData.TimeTables[i].SubjectName));
            if (index > -1) {
              resData.TimeTables[i].color = this.xy.colors(index).color;
              resData.TimeTables[i].bg = this.xy.colors(index).bg;
            } else {
              resData.TimeTables[i].color = this.xy.colors(array.length).color;
              resData.TimeTables[i].bg = this.xy.colors(array.length).bg;
              array.push(String(resData.TimeTables[i].SubjectName));
            }
            if (resData.TimeTables[i].StartTime !== null) {
              resData.TimeTables[i].StartTime = this.xy
                .moment("2018-08-08 ".replace(/-/g, "/") + resData.TimeTables[i].StartTime)
                .format("HH:mm");
            }
            if (resData.TimeTables[i].EndTime !== null) {
              resData.TimeTables[i].EndTime = this.xy
                .moment("2018-08-08 ".replace(/-/g, "/") + resData.TimeTables[i].EndTime)
                .format("HH:mm");
            }
          }
        } else if (resData.TimeTables.length === 1) {
          resData.TimeTables[0].color = this.xy.colors(0).color;
          resData.TimeTables[0].bg = this.xy.colors(0).bg;
        }
        if (!weekOrday) {
          //周
          this.tableScheduleData = [];
          this.tableScheduleData = resData.TimeTables;
          // console.log( this.weekTable, this.tableSchedule)
        } else {
          //当天
          this.liScheduleData = [];
          this.liScheduleData = resData.TimeTables;
        }
        this.isWeekDataShow = false;
      } else {
        this.xy.msgError(res.msg);
      }
    },
    //获取周次信息
    async getWeek(id) {
      const params = {
        academicSessionID: id,
        StudentID: this.StudentID
      };
      const res = await this.xyapi.get(
        this.xyMApi + "/api/MyTimeTable/GetWeek",
        params
      );
      if (res.success) {
        var resDataListWeek = res.data.ListWeek;
        this.curDate = `${this.xy
          .moment(res.data.WeekStartDate)
          .format("YYYY年MM月DD日")} -- ${this.xy
          .moment(res.data.WeekStartDate)
          .add(6, "day")
          .format("YYYY年MM月DD日")}`;
        this.weekData = [];
        if (resDataListWeek.length > 0) {
          for (var i = 0; i < resDataListWeek.length; i++) {
            var num = "";
            if (resDataListWeek[i].Week !== "本周") {
              num = "第" + resDataListWeek[i].Week + "周";
            } else {
              num = resDataListWeek[i].Week;
            }
            this.weekData.push({
              id: resDataListWeek[i].Week,
              name:
                num +
                `${this.xy.moment(resDataListWeek[i].Date).format("YYYY/MM/DD")} - ${this.xy
                  .moment(resDataListWeek[i].Date)
                  .add(6, "day")
                  .format("YYYY/MM/DD")}`,
              startDate: resDataListWeek[i].Date
            });
          }
          this.weekTable = [];
          for (var j = 0; j < 7; j++) {
            var date1 = this.xy
              .moment(res.data.WeekStartDate)
              .add(j, "day")
              .format("MM/DD");
            this.weekTable.push({
              weekName: this.xy.getChinesesWeekForNumSmall(j),
              dateTime: this.xy
                .moment(res.data.WeekStartDate)
                .add(j, "day")
                .format("YYYY-MM-DD"),
              dateDay: date1,
              day: j,
              isCur: j === new Date().getDay() - 1 ? true : false
            });
          }
        }

        if (this.isDay) {
          //今天
          this.curDay = new Date().getDay() - 1; //当前周几
          var curDate = this.xy.moment().format("YYYY-MM-DD");
          this.getWeekTimeTable(curDate, curDate, this.isDay);
        } else {
          //周
          this.getWeekTimeTable(
            res.data.WeekStartDate,
            this.xy
              .moment(res.data.WeekStartDate)
              .add(6, "day")
              .format("YYYY-MM-DD"),
            this.isDay
          );
        }
      } else {
        this.xy.msgError(res.msg);
      }
    },
    ChangeWeek(e) {
      //选择不同的周
      this.tab = 0;
      this.curWeek = e.id;
      this.curDate = `${this.xy.moment(e.startDate).format("yyyy年MM月dd日")} - ${this.xy
        .moment(e.startDate)
        .add(6, "day")
        .format("yyyy年MM月dd日")}`;
      this.weekTable = [];
      for (var k = 0; k < 7; k++) {
        var date1 = this.xy
          .moment(e.startDate)
          .add(k, "day")
          .format("MM/DD");
        this.weekTable.push({
          weekName: this.xy.getChinesesWeekForNumSmall(k),
          dateDay: date1,
          dateTime: this.xy
            .moment(e.startDate)
            .add(k, "day")
            .format("YYYY-MM-DD"),
          day: k,
          isCur: k === 0 ? true : false
        });
      }
      if (this.isDay) {
        //今天
        this.curDay = 0; //当前周几
        this.getWeekTimeTable(e.startDate, e.startDate, this.isDay);
      } else {
        //周
        this.getWeekTimeTable(
          e.startDate,
          this.xy
            .moment(e.startDate)
            .add(6, "day")
            .format("YYYY-MM-DD"),
          this.isDay
        );
      }
    },
    //获取学年
    async getYear() {
      const res = await this.xyapi.get(
        this.xyMApi + `/xy/comm/YearList?StudentID=${this.StudentID}`
      );
      if (res.success) {
        this.yearData = res.data;
        if (res.data.length > 0) {
          var arr = res.data.filter(item => {
            return item.IsCurrent === true;
          });
          if (arr.length > 0) {
            this.yearID = arr[arr.length - 1].ID;
          } else {
            this.yearID = res.data[res.data.length - 1].ID;
          }
        }
        this.getSession(this.yearID);
      } else {
        this.xy.msgError(res.msg);
      }
    },
    //获取学期
    async getSession(id) {
      const params = {
        yearID: id
      };
      const res = await this.xyapi.get(
        this.xyMApi + `/xy/comm/SessionList?StudentID=${this.StudentID}`,
        params
      );
      if (res.success) {
        this.sessionData = [];
        this.sessionID = 0;
        if (res.data.length > 0) {
          this.sessionData = res.data;
          var arr = res.data.filter(item => {
            return item.IsCurrent === true;
          });
          if (arr.length > 0) {
            this.sessionID = arr[arr.length - 1].AcademicSessionID;
          } else {
            this.sessionID = res.data[res.data.length - 1].AcademicSessionID;
          }
        }
        this.getWeek(this.sessionID);
      } else {
        this.xy.msgError(res.msg);
      }
    },
    //点击周或者今
    dayOrWeekClick(val) {
      if (val === this.isDay) {
        return false;
      }
      this.isDay = !this.isDay;
      var curTime = "";
      this.weekData.map(item => {
        if (item.id === "本周") {
          curTime = item.startDate;
          this.curWeek = item.id;
          this.curDate = `${this.xy.moment(item.startDate).format("YYYY年MM月DD日")} -- ${this.xy
            .moment(item.startDate)
            .add(6, "day")
            .format("YYYY年MM月DD日")}`;
          this.weekTable = [];
          for (var k = 0; k < 7; k++) {
            var date1 = this.xy
              .moment(item.startDate)
              .add(k, "day")
              .format("MM/DD");
            this.weekTable.push({
              weekName: this.xy.getChinesesWeekForNumSmall(k),
              dateDay: date1,
              dateTime: this.xy
                .moment(item.startDate)
                .add(k, "day")
                .format("YYYY-MM-DD"),
              day: k,
              isCur: k === new Date().getDay() - 1 ? true : false
            });
          }
        }
        return item;
      });
      if (this.isDay) {
        //今
        this.curDay = new Date().getDay() - 1; //当前周几
        this.tab = this.curDay; //选中今天是周几的样式
        var curDay = this.xy.moment().format("YYYY-MM-DD");
        this.getWeekTimeTable(curDay, curDay, this.isDay);
      } else {
        //周
        this.tab = 0;
        this.getWeekTimeTable(
          curTime,
          this.xy
            .moment(curTime)
            .add(6, "day")
            .format("YYYY-MM-DD"),
          this.isDay
        );
      }
    },
    //点击当周的周几
    dayChange(val, index) {
      this.tab = index;
      this.curDay = val.day; //当前第几周
      this.weekTable.map(item => {
        return (item.isCur = false);
      });
      val.isCur = true;
      this.getWeekTimeTable(val.dateTime, val.dateTime, this.isDay);
    },
    changeTab(val) {
      this.tab = val;
    }
  },
  created: function() {
    this.StudentID = this.ChildrenID;
    this.getYear();
  }
};
</script>

<style lang="less" scoped>
/*
  * 引自 YDUI - 滚动导航
  * http://vue.ydui.org/docs/#/scrollnav
  */

.yd-scrollnav {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
}

.yd-scrollnav,
.yd-scrollnav-tab {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
}

.yd-scrollnav-tab {
  position: relative;
}

.yd-scrollnav-tab-item {
  white-space: nowrap;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  & > li {
    padding: 0 20px;
    font-size: 28px;
    display: inline-block;
    position: relative;
    height: inherit;
    &.yd-scrollnav-current {
      color: currentColor !important;
      padding-left: 32px;
      & > i {
        width: 32px;
        height: inherit;
        position: absolute;
        top: 0;
        left: 10px;
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -webkit-align-items: center;
        -ms-flex-align: center;
        align-items: center;
        &:before {
          content: "\E651";
          font-family: YDUI-INLAY;
          font-size: 32px;
          line-height: 1;
        }
      }
    }
  }
}

.yd-scrollnav-tab-item > li > span,
.yd-scrollnav-toggle {
  height: inherit;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}

.yd-scrollnav-toggle {
  width: 100px;
  -webkit-box-pack: center;
  -webkit-justify-content: center;
  -ms-flex-pack: center;
  justify-content: center;
  &:after {
    content: "\E68C";
    font-family: YDUI-INLAY;
    display: block;
    -webkit-transform: rotate(0deg);
    transform: rotate(0deg);
    -webkit-transition: -webkit-transform 0.08s linear;
    transition: -webkit-transform 0.08s linear;
    transition: transform 0.08s linear;
    transition: transform 0.08s linear, -webkit-transform 0.08s linear;
    font-size: 0.32rem;
    color: currentColor;
  }
  &-active:after {
    -webkit-transform: rotate(180deg);
    transform: rotate(180deg);
  }
}

.yd-scrollnav-unfold {
  position: absolute;
  z-index: 2;
  width: 100%;
  top: 0;
  pointer-events: none;
  opacity: 0;
  -webkit-transform: translateY(-100%);
  transform: translateY(-100%);
  -webkit-transition: all 0.08s linear;
  transition: all 0.08s linear;
  &-active {
    opacity: 1;
    -webkit-transform: translate(0);
    transform: translate(0);
  }
  &-header {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    position: relative;
    border-width: 0 0 1px;
    border-style: solid;
    & > div {
      -webkit-box-flex: 1;
      -webkit-flex: 1;
      -ms-flex: 1;
      flex: 1;
      padding-left: 0.3rem;
      font-size: 0.28rem;
      color: #333;
    }
    & > span {
      width: 1rem;
    }
  }
  & > ul {
    pointer-events: auto;
    overflow: hidden;
    padding-bottom: 0.2rem;
    padding-top: 0.2rem;
    & > li {
      float: left;
      width: 33.333%;
      padding-left: 0.3rem;
      line-height: 0.7rem;
      font-size: 0.28rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      &.yd-scrollnav-current {
        color: currentColor !important;
      }
    }
  }
}

.yd-scrollnav-content {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  -ms-flex: 1;
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}
</style>

<style lang="less" scoped>
.class-head {
  position: fixed;
  top: 90px;
  width: 100%;
  height: 350px;
  background: #4196ff;
  background-image: url("~@/assets/homeSchool/roundBar-blue@2x.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  z-index: 99;
}

.class-flex {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  padding: 0 20px;
  height: 100px;
  width: 70%;
  margin: 20px auto 40px auto;
  & > .date {
    font-size: 28px;
    opacity: 0.89;
    width: 80px;
    height: 80px;
    border-radius: 50%;
    text-align: center;
    line-height: 80px;
    border: 1px solid #fff;
    color: rgba(255, 255, 255, 1);
    background: #1865e1;
  }
  & > div {
    width: 320px;
    height: 60px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 30px;
    background: rgba(0, 0, 0, 0.15);
    padding: 0 20px;
    font-size: 24px;
    color: #fff;
    & > i {
      font-size: 36px;
    }
  }
}

.week {
  width: 240px;
  padding: 20px;
  background: rgba(0, 0, 0, 0.15);
  border-radius: 15px;
  margin: 0 20px;
  color: #fff;
  text-align: center;
  position: relative;
  & i {
    position: absolute;
    right: 20px;
    top: 25px;
  }
}

.class-head .scrollnav-btn-week {
  padding: 0;
  line-height: 110px;
}

.active_date {
  color: #1865e1 !important;
  background: rgba(255, 255, 255, 1) !important;
}

/* 星期样式 */
.yd-scrollnav-tab-item {
  padding: 0 40px;
  & > li {
    width: 110px;
    height: 110px;
    background: rgba(249, 249, 249, 0.2);
    border-radius: 34px;
    padding: 20px;
    margin-right: 30px;
    text-align: center;
    & > p:first-child {
      /* margin-bottom: 30px; */
      color: #fff;
      font-weight: bold;
      font-size: 28px;
    }
    & > p:last-child {
      color: #f9f9f9;
      font-size: 24px;
      font-weight: normal;
    }
  }
}

.active_tab {
  /* opacity: 1 !important; */
  background: rgba(249, 249, 249, 1) !important;
  & > p:first-child {
    font-weight: bold;
    color: rgba(7, 0, 97, 1) !important;
  }
  & > p:last-child {
    font-weight: bold;
    color: #9d97bd !important;
  }
}

.radius {
  width: 100%;
  /* margin-top: 460px; */
  padding: 30px;
  background: rgba(249, 249, 249, 1);
  border-radius: 90px 90px 0 0;
  position: absolute;
  bottom: 0;
}

/* 具体的课程表 */
.class_info {
  width: 100%;
  margin-top: 360px;
  padding: 30px;
  background: rgba(249, 249, 249, 1);
  & > ul {
    border-left: 1px dashed #b6baca;
    margin-left: 16px;
    & > li {
      display: flex;
      margin-bottom: 60px;
      padding: 20px 30px;
      align-items: center;
      padding-left: 0;
      position: relative;
      height: 100px;
      & > img {
        width: 40px;
        height: 40px;
        position: absolute;
        left: 0px;
        top: 0px;
        transform: translate(-50%);
      }
      & > span,
      & > p {
        position: absolute;
        z-index: 1;
        left: 40px;
        display: block;
      }
      & > span {
        color: rgba(51, 51, 51, 1);
        font-size: 24px;
        top: 10px;
      }
      & > p {
        color: rgba(102, 102, 102, 1);
        top: 50px;
        font-size: 18px;
      }
      & > div {
        display: block;
        min-height: 100px;
        max-height: 100px;
        overflow-y: auto;
        border-radius: 14px;
        position: absolute;
        z-index: 1;
        left: 120px;
        right: 0;
        top: -10px;
        padding-left: 30px;
      }
    }
  }
}

.class_text .address {
  width: 100%;
  padding: 25px 0 25px 0;
  font-size: 28px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.class_text .time {
  font-size: 18px;
  padding-bottom: 10px;
}

.class_info > ul > li:last-child:before {
  content: "";
  width: 4px;
  height: 100%;
  background-color: rgba(249, 249, 249, 1);
  position: absolute;
  left: -3px;
}

.change-bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: #fff;
  z-index: 99999;
  &-img {
    position: absolute;
    bottom: -30px;
    width: 100%;
  }
}

.child-info {
  position: absolute;
  top: 200px;
  left: 50%;
  z-index: 2;
  margin-left: -85px;
  & > div.change-active {
    background: #4196ff;
    color: #fff;
    border: 0px;
  }
}
</style>
